import React, { useEffect } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { listCustomers } from '../actions/userActions'
import { formatCurrency } from '../utils/currency'

const CustomerListScreen = ({ history }) => {
  const dispatch = useDispatch()

  const customerList = useSelector((state) => state.customerList)
  const { loading, error, customers } = customerList

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (userInfo && userInfo.isAdmin) {
      dispatch(listCustomers())
    } else {
      history.push('/login')
    }
  }, [dispatch, history, userInfo])

  return (
    <section className='minHeight100 my-5'>
      <div className='container'>
        <h1 className='commonTitle--xl mb-5'>Customers</h1>
        {loading ? (
          <Loader />
        ) : error ? (
          <Message variant='danger'>{error}</Message>
        ) : (
          <Table striped bordered hover responsive className='table-sm'>
            <thead>
              <tr>
                <th>Customer name</th>
                <th>Phone</th>
                <th>Location</th>
                <th>Orders</th>
                <th>Amount spent</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <tr key={customer._id}>
                  <td>{[customer.firstName, customer.lastName].filter(Boolean).join(' ') || 'N/A'}</td>
                  <td>{customer.phone || 'N/A'}</td>
                  <td>{customer.location || 'N/A'}</td>
                  <td>{customer.orders ?? 0}</td>
                  <td>{formatCurrency(customer.amountSpent || 0)}</td>
                  <td>
                    <LinkContainer to={`/admin/customer/${customer._id}`}>
                      <button className='btn btn-sm btn-outline-dark'>View</button>
                    </LinkContainer>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </section>
  )
}

export default CustomerListScreen
